import {Fragment, useEffect, useState} from "react";
// import * as fs from "fs";
// import * as path from "path";

interface Params {
	id?: string
	className?: string
	root: {
		animations: any[]
	}
	fps?: number // 每秒帧数
	spacing?: number // 步长
}

function processSpacing(animations: any[], spacing = 1) {
	const res = [animations[0]]; let lastIdx = 0;
	animations.forEach((ani, idx) => {
		if (idx != lastIdx + spacing) return;
		res.push(ani); lastIdx = idx;
	})
	return res;
}

export function FramedVideo({root, id = "", className = "", fps = 20, spacing = 1}: Params) {

	let loadCnt = 0;

	const [index, setIndex] = useState(0);
	const [allLoaded, setAllLoaded] = useState(false);

	const onImgLoad = (e: any) => {
		console.log("onImgLoad", loadCnt, count, allLoaded);
		if (!allLoaded && ++loadCnt >= count) setAllLoaded(true)
	}

	const anis = processSpacing(root.animations, spacing);
	const count = anis.length;
	const imgs = anis.map((ani, i) =>
		<img id={id} className={className}
				 style={{display: i == index ? "block" : "none"}}
				 onLoad={onImgLoad} src={(ani)}/>);

	useEffect(() => {
		if (!allLoaded) return;
		setTimeout(() => {
				// console.log("index", index)
				setIndex((index + 1) % count)
			},
			1000 / fps);
	}, [index, allLoaded]);

	return <Fragment>
		{imgs}
		{/*<div style={{position: "fixed", left: "100vw"}}>{imgs}</div>*/}
	</Fragment>;
}
